import React from 'react';

const QueueStatus = ({ requestQueue }) => {
  if (!requestQueue.length) return null;

  return (
    <div className="flex items-center space-x-2 text-sm text-gray-600 mb-2">
      <div className="flex items-center bg-blue-50 text-blue-700 px-2 py-0.5 rounded-md">
        <svg className="animate-spin h-3 w-3 mr-1.5" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
        </svg>
        <span>
          Fetching Zillow data for {requestQueue.length} properties
          (Est. {Math.ceil(requestQueue.length * 1.1)}s remaining)
        </span>
      </div>
    </div>
  );
};

export default QueueStatus;